// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalCancelarMeta_iconHeader__UoZo5","form":"ModalCancelarMeta_form__+INaD","containerButtons":"ModalCancelarMeta_containerButtons__Ul393"};